import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { ScrollToTop } from "./components/ScrollToTop";
import { ErrorBoundary } from "./components/ErrorBoundary";
import Index from "./pages/Index";
import { ProductsListingPage } from "./pages/ProductsListingPage";
import { ProductPage } from "./pages/ProductDetailsPage";
import { ProductenPage } from "./pages/ProductenPage";
import OnsVerhaalPage from "./pages/OnsVerhaalPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { OrderConfirmationPage } from "./pages/OrderConfirmationPage";
import { RetourPage } from "./pages/RetourPage";
import { AlgemeneVoorwaardenPage } from "./pages/AlgemeneVoorwaardenPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import NotFound from "./pages/NotFound";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { ProtectedAdminRoute } from "./components/ProtectedAdminRoute";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <CartProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <ErrorBoundary
              section="App"
              fallback={
                <div className="min-h-screen flex items-center justify-center p-4">
                  <div className="text-center space-y-4">
                    <p className="text-lg">Er ging iets mis bij het laden van de pagina.</p>
                    <button 
                      onClick={() => window.location.href = `/?v=${Date.now()}`}
                      className="px-6 py-3 bg-gold text-white rounded-lg hover:bg-gold/90 transition-colors"
                    >
                      Herlaad pagina
                    </button>
                  </div>
                </div>
              }
            >
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/ons-verhaal" element={<OnsVerhaalPage />} />
                <Route path="/producten" element={<ProductenPage />} />
                <Route path="/producten/:slug" element={<ProductPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/bestelling-bevestiging" element={<OrderConfirmationPage />} />
                <Route path="/retour" element={<RetourPage />} />
                <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaardenPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route
                  path="/admin/dashboard"
                  element={
                    <ProtectedAdminRoute>
                      <AdminDashboardPage />
                    </ProtectedAdminRoute>
                  }
                />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
        </BrowserRouter>
      </TooltipProvider>
    </CartProvider>
  </QueryClientProvider>
);

export default App;
